import Vue from 'vue';

import AdvButton from '@advisor/components/common/AdvButton.vue';
import AdvSwitch from '@advisor/components/common/AdvSwitch.vue';
import AdvCheckbox from '@advisor/components/common/AdvCheckbox.vue';
import AdvLoader from '@advisor/components/common/AdvLoader.vue';

import LegacyRwImage from '@advisor/components/common/LegacyRwImage.vue';
import RWLoader from '@advisor/components/RwLoader2.vue';
import DesignBank from '@simpleinvest/design-bank-vue';
import '@simpleinvest/design-bank-vue/dist/DesignBank.css';

Vue.use(DesignBank);

Vue.component('AdvButton', AdvButton);
Vue.component('AdvSwitch', AdvSwitch);
Vue.component('AdvCheckbox', AdvCheckbox);
Vue.component('LegacyRwImage', LegacyRwImage);
Vue.component('RwLoader', RWLoader);
Vue.component('AdvLoader', AdvLoader);
Vue.component('AdvMaskedSsn', () => import('@advisor/components/common/AdvMaskedSsn'));
Vue.component('AdvMaskedInput', () => import('@advisor/components/common/AdvMaskedInput'));
Vue.component('AdvPhone', () => import('@advisor/components/common/AdvPhone'));
